import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("Verifying payment...");

  useEffect(() => {
    const verifyPayment = async () => {
      const session_id = params.get("session_id");

      if (!session_id) {
        setStatus("Invalid session");
        return;
      }

      try {
        const res = await fetch(
          `https://event.greatnigerian.org/api/event/verify-payment/?session_id=${session_id}`
        );

        const data = await res.json();

        if (res.ok) {
          setStatus("✅ Payment successful! Check your email.");
        } else {
          setStatus(data.error || "Verification failed");
        }
      } catch (err) {
        setStatus("Network error. Please contact support.");
      }
    };

    verifyPayment();
  }, [params]);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h1>Payment Status</h1>
      <p>{status}</p>
    </div>
  );
};

export default PaymentSuccess;